import { API_ROOT } from '../../config/config'
import { doPost, doGet, doPostFiles, doPut, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9015/api'

export const getCallBookNotice = () => {
  const url = `${API_ROOT}/v1/legal/notice/page`
  return doGet(url)
}

export const searchCallBookNotice = (request) => {
  const url = `${API_ROOT}/v1/legal/notice/search`
  return doPost(url, request)
}

export const getCallBookNoticeByid = (litigationId, noticeId) => {
  const url = `${API_ROOT}/v1/legal/notice/get?litigationId=${litigationId}&&noticeId=${noticeId}`
  return doGet(url)
}

export const saveCallBookNotice = (request, litigationId) => {
  const url = `${API_ROOT}/v1/legal/notice/save/${litigationId}`
  return doPostFiles(url, request)
}

export const sendRequestApproveCallBookNotice = (noticeId) => {
  const url = `${API_ROOT}/v1/legal/notice/request-approve/${noticeId}`
  return doPost(url)
}

export const approvedCallBookNotice = (litigationId, request) => {
  // /api/v1/legal/notice/approved/{litigationId}
  const url = `${API_ROOT}/v1/legal/notice/approved/${litigationId}`
  return doPut(url, request)
}

export const downloadCallBookNotice = (litigationNoticeId) => {
  const url = `${API_ROOT}/files/${litigationNoticeId}/litigation/notice/letter`
  return doDownload(url)
}
